import { DocumentItem } from '../types/documentation';

const API_BASE_URL = process.env.REACT_APP_API_URL?.replace('/api/v1', '') || 'https://e-unify-ai-backend-production-458e.up.railway.app';

// Prefer static manifest generated at build time. Fallback to backend API if not present.
export const getDocumentationFiles = async (): Promise<DocumentItem[]> => {
  // 1) Try static manifest
  try {
    const staticResp = await fetch('/docs-index.json', { cache: 'no-store' });
    if (staticResp.ok) {
      const data = await staticResp.json();
      if (Array.isArray(data)) return data as DocumentItem[];
    }
  } catch (_) {
    // ignore and fallback
  }

  // 2) Fallback to backend endpoint if available
  try {
    const response = await fetch(`${API_BASE_URL}/md/list`);
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    const data = await response.json();
    if (!Array.isArray(data)) throw new Error('Invalid response format - expected array');
    return data as DocumentItem[];
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error('Error loading documentation list:', error.message);
    }
    return [];
  }
};

export const getDocumentContent = async (filename: string): Promise<string> => {
  if (!filename || typeof filename !== 'string') {
    throw new Error('Invalid filename parameter');
  }

  try {
    // 1) If caller passed an explicit web path, honor it directly
    if (filename.startsWith('/docs/') || filename.startsWith('/md/')) {
      const response = await fetch(filename, { cache: 'no-store' });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await response.text();
    }

    // 2) For bare markdown filenames (no slash), prefer static copies first
    const looksLikeSimpleMarkdown = filename.endsWith('.md') && !filename.includes('/');
    if (looksLikeSimpleMarkdown) {
      const staticCandidates = [`/docs/${encodeURIComponent(filename)}`, `/${encodeURIComponent(filename)}`];
      for (const url of staticCandidates) {
        try {
          const resp = await fetch(url, { cache: 'no-store' });
          if (!resp.ok) continue;
          const text = await resp.text();
          if (text.trim().length > 0) {
            return text;
          }
        } catch {
          // try next candidate
        }
      }
    }

    // 3) Fallback to backend /md endpoint
    const backendUrl = `${API_BASE_URL}/md/${encodeURIComponent(filename)}`;
    const response = await fetch(backendUrl, { cache: 'no-store' });
    if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    return await response.text();
  } catch (error: unknown) {
    if (error instanceof Error) {
      console.error(`Error loading ${filename}:`, error.message);
    }
    return '';
  }
};
